// src/hooks/useInstances.ts
import { useState, useCallback } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { Instance, InstanceCreatePayload, InstancesApiResponse, InstanceSearchParams, InstanceUpdatePayload } from "types/superAdmin/instanceTypes";
import { getAllInstances, createInstance, updateInstance, UpdateInstancePayloadForApi, CreateInstancePayloadForApi, deleteInstance , activateInstance } from "services/superAdmin/instenceService";

export const useInstances = () => {
  const { t } = useTranslation();

  const [instances, setInstances] = useState<Instance[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [infoPagination, setInfoPagination] = useState<any>({});

  // UI state
  const [selectedInstance, setSelectedInstance] = useState<Instance | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  /**
   * Fetch all instances
   */
  const fetchInstances = useCallback(
    async (filters: InstanceSearchParams = {}) => {
      setLoading(true);
      try {
        const response: InstancesApiResponse = await getAllInstances(filters);
        setInstances(response?.data || []);
        setInfoPagination(response?.pagination);
        setError(null);
      } catch (err) {
        console.error(err);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [t]
  );

  /**
   * Create a new instance
   */
  const handleCreate = async (payload: CreateInstancePayloadForApi) => {
    try {
      await createInstance(payload);
      message.success(t("instance_added_successfully"));
      // await fetchInstances();
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const handleUpdate = async (id: string, payload: UpdateInstancePayloadForApi) => {
    try {
      await updateInstance(id, payload);
      message.success(t("instance_updated_successfully"));
      // await fetchInstances();
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };


  const handleDelete = async (instanceId: string) => {
    try {
      await deleteInstance(instanceId);
      message.success(t("instance_deleted_successfully"));
      // await fetchInstances();
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };
  
    const handleActivateInstance = async (instanceId: string) => {
    try {
      await activateInstance(instanceId);
      message.success(t("instance_updated_successfully"));
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  }; 
  
  
  return {
    instances,
    loading,
    error,
    selectedInstance,
    setSelectedInstance,
    isModalOpen,
    setIsModalOpen,
    fetchInstances,
    handleCreate,
    handleUpdate,
    infoPagination,
    handleDelete,
    handleActivateInstance
  };
};

export default useInstances;
